<template>
  <div>
    <page-main
      ref="main"
      :disabled="disabled"
      :loading="loading"
      :tableData="tableData"
      @reload="getData"
      @openEditDialog="openEditDialog"
      @del="(code) => submitDel([code])"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @openEditDialog="openEditDialog"
        @del="batchDel"
      />
    </page-main>

    <EditFormDialog
      :visible.sync="EditFormDialogOptions.visible"
      :title="EditFormDialogOptions.title"
      :disabled="EditFormDialogOptions.disabled"
      :pdCostsOrderGoodsSpecFabricCode="
        EditFormDialogOptions.pdCostsOrderGoodsSpecFabricCode
      "
      :pdCostsOrderGoodsSpecCode="pdCostsOrderGoodsSpecCode"
      @reload="editReload"
    />
  </div>
</template>
<script>
import EditFormDialog from './edit-form'
import PageHeader from './header.vue'
import PageMain from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, PageHeader, EditFormDialog },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    pdCostsOrderGoodsSpecCode: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      EditFormDialogOptions: {
        visible: false,
        title: '',
        disabled: false,
        pdCostsOrderGoodsSpecFabricCode: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.pdCostsOrderGoodsSpecCode) return
      this.loading = true
      const res = await this.$api
        .pdCostsOrderGoodsSpecFabricListApi({
          pdCostsOrderGoodsSpecCode: this.pdCostsOrderGoodsSpecCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
    editReload() {
      this.getData()
      this.$emit('reload')
    },
    openEditDialog({ optType = '', data = {} }) {
      const types = {
        add: this.$l('dialog_title_add_pdCostsOrderGodsSpecFabric'),
        edit: this.$l('dialog_title_edit_pdCostsOrderGodsSpecFabric'),
        detail: this.$l('dialog_title_detail_pdCostsOrderGodsSpecFabric'),
      }
      this.EditFormDialogOptions = {
        visible: true,
        title: types[optType] || '',
        disabled: optType === 'detail',
        pdCostsOrderGoodsSpecFabricCode: data.pdCostsOrderGoodsSpecFabricCode,
      }
    },
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (!listCode) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }
      this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .pdCostsOrderGoodsSpecFabricDelApi({ listCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.editReload()
      })
    },
  },
}
</script>
